import { deserializeRegistration } from './deserialize-registration';
import { serializeRegistration } from './serialize-registration';
import {
  RegistrationDataT,
  RegistrationRequestT,
  RegistrationResponseT,
} from '../../types';
import { TransformT } from '../../types/transform';

export const registrationTransform: TransformT<Partial<RegistrationDataT>, RegistrationResponseT, RegistrationRequestT> = {
  deserialize: deserializeRegistration,
  serialize: serializeRegistration,
};
